// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UZt8","col":"styles_col__3zntg"};